import {z} from 'zod';

import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {
  AccountingMatrixDatagridConfig,
  getAccountingMatrixDatagridSharedFields,
} from '../../utils/accountingMatrixDatagridConfig';

export const getAccountingMatrixDatagridM13VatConfig = (): AccountingMatrixDatagridConfig => ({
  dgCode: 'm13-vat',
  fields: [
    {
      name: 'code',
      label: i18n.t('page.accounting.labels.accountingMatrixDatagridsFieldCode'),
      type: 'text',
      isRequired: true,
    },
    {
      name: 'name',
      label: i18n.t('general.labels.name'),
      type: 'text',
      isRequired: true,
    },
    {
      // The API takes vatPercent as a string ("21"), the number widget is just nicer UX.
      name: 'vatPercent',
      label: i18n.t('page.accounting.labels.accountingMatrixDatagridsFieldVatPercent'),
      type: 'number',
      isRequired: true,
      fromRecord: (record) => {
        const value = record.vatPercent;
        if (typeof value !== 'string') {
          return value;
        }
        return value === '' ? null : Number(value);
      },
      toBody: (value) => (isNilOrEmpty(value) ? null : String(value)),
    },
    {
      // Not in the swagger's `required` list, but M205/Operation Items both turned out to have
      // NOT NULL DB columns BE doesn't validate at the API layer (T20-137885/T20-137887) — made
      // required here as a precaution too. Relax if BE confirms it's actually nullable.
      name: 'vatAccount',
      label: i18n.t('page.accounting.labels.accountingMatrixDatagridsFieldVatAccount'),
      type: 'text',
      isRequired: true,
    },
    ...getAccountingMatrixDatagridSharedFields(),
  ],
  schema: z.object({
    code: z.string().min(1),
    name: z.string().min(1),
    vatPercent: z.number().min(0).max(100),
    vatAccount: z.string().min(1),
    billingInformation: z.string().min(1),
    validFrom: z.string(),
    validTo: z.string(),
  }),
});
